import {Toaster, Type} from './toaster/Toaster';
import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {Keys, StorageService} from './service/storage.service';
import {DOCUMENT} from '@angular/common';
import {isNullOrUndefined} from 'util';
import {VerificationState} from './model/verification-state.model';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {AnalyticsTracker} from './utils/AnalyticsTracker';
import {ConfigService} from './service/config.service';
import {Meta} from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    private document: any;
    private router: Router;
    private route: ActivatedRoute;
    private storageService: StorageService;
    private analyticsTracker: AnalyticsTracker;
    private configService: ConfigService;
    private metaService: Meta;

    constructor(storageService: StorageService, route: ActivatedRoute, @Inject(DOCUMENT) document: any, router: Router, analyticsTracker: AnalyticsTracker, configService: ConfigService, metaService: Meta) {
        this.route = route;
        this.router = router;
        this.document = document;
        this.storageService = storageService;
        this.analyticsTracker = analyticsTracker;
        this.configService = configService;
        this.metaService = metaService;

        this.addMetaTags();
    }

    @HostListener('window:online', ['$event'])
    onOnlineEvent(): void {
        Toaster.toast(`We're back online! Please reload the page to ensure everything is up to date.`, Type.Success);
    }

    @HostListener('window:offline', ['$event'])
    onOfflineEvent(): void {
        Toaster.toast(`You seem to be offline. Please check your internet connection and reload.`, Type.NonDismissibleAlert);
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (!isNullOrUndefined((params['partner'] || params['referrer']))) {
                this.storageService.saveObjectToSession(Keys.REFERRER_CODE, (params['partner'] || params['referrer']));
                this.storageService.saveObjectToSession(Keys.VERIFICATION_STATE, VerificationState.NA);
            }
        });

        this.setupPartnerIfApplicable();

        this.analyticsTracker.createGoogleAnalyticsTracker(this.configService.getGoogleAnalyticsTrackerId());
        this.analyticsTracker.setUserId();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.analyticsTracker.trackPageView(event.urlAfterRedirects);
            }
        });
    }

    private setupPartnerIfApplicable() {
        const domain = this.document.location.hostname;
        const partnerName = 'tripfactory';
        const defaultDomain = 'finzy';

        if (domain.split('.')[0] === partnerName) {
            this.storageService.saveItem(Keys.DOMAIN, partnerName);
            this.storageService.saveItem(Keys.PARTNER, partnerName);
        } else {
            this.storageService.saveItem(Keys.DOMAIN, defaultDomain);
            this.storageService.removeItem(Keys.PARTNER);
        }
    }

    private addMetaTags() {
        this.metaService.addTag({ name: 'insight-app-sec-validation', content: this.configService.getInsightAppSecValidationContent() });
    }
}
